import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['fileName', 'fileCsv', 'preview', 'form', 'formButton', 'loading']

  onChangeFileUserCsv(event) {
    this.fileNameTarget.innerText = event.target.files[0].name;

    const formData = new FormData(this.formTarget);

    Rails.ajax({
      url: '/admin/health_check_reservation_lists/tak_csv_preview',
      type: 'POST',
      dataType: 'html',
      data: formData,
      beforeSend: () => {
        try {
          this.showLoading();
          if (this.hasFormButtonTarget) this.formButtonTarget.classList.add("is-hidden");
        } catch (e) {
          throw e
        }
        return true
      },
      success: (response)=> {
        this.previewTarget.innerHTML = response.body.innerHTML;
        if(document.querySelector(".error") == undefined) {
          this.formButtonTarget.classList.remove("is-hidden");
        }else{
          this.formButtonTarget.classList.add("is-hidden");
        }
      },
      error: (response)=> {
          this.previewTarget.innerHTML = "<div class='notification mb-2 is-warning'>エラーが発生しました。アップロードしたファイルを読み込めません。</div>";
          this.formButtonTarget.classList.add("is-hidden");
      },
      complete: () => {
        this.hideLoading();
      }
    });
  }

  onClickFileCsv(event) {
    event.stopPropagation()

    this.fileCsvTarget.value = null
  }

  onSubmit(event){
    this.formTarget.submit();
  }
  showLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("is-hidden")
  }
  hideLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.add("is-hidden")
  }

}
